import { useConfig } from 'config/use-config';
import { useCookiebotCategoryConsent } from 'modules/consent/consent';
import { useEffect } from 'react';

export const useSyncConsentWithMida = (): null => {
  const { midaKey } = useConfig();
  const hasStatisticsConsent = useCookiebotCategoryConsent('statistics');

  useEffect(() => {
    if (!midaKey || !window.mida || !window.Cookiebot?.hasResponse) {
      return;
    }

    window.mida.grantConsent(hasStatisticsConsent);
  }, [hasStatisticsConsent, midaKey]);

  return null;
};
